export interface ReactNativeAudioFile {
  uri: string;
  type: string;
  name: string;
}

export interface TranscribeAudioParams {
  audioBlob: Blob | ReactNativeAudioFile;
  listingId?: string;
  userId?: string;
}

export interface TranscribeAudioResponse {
  text: string;
  language: string;
  duration: number;
}

export async function transcribeAudio({
  audioBlob,
  listingId,
  userId,
}: TranscribeAudioParams): Promise<TranscribeAudioResponse> {
  const formData = new FormData();
  
  // Support both web Blob and React Native file format
  if (audioBlob instanceof Blob) {
    formData.append("file", audioBlob, "recording.webm");
  } else {
    // React Native format with uri, type, name
    formData.append("file", audioBlob as any);
  }

  // Add optional parameters if provided
  if (listingId) {
    formData.append("listing_id", listingId);
  }
  if (userId) {
    formData.append("user_id", userId);
  }

  const apiUrl = process.env.NEXT_PUBLIC_API_URL_AI || process.env.EXPO_PUBLIC_API_URL_AI || "http://localhost:8000";
  const res = await fetch(`${apiUrl}/api/v1/voice/transcribe`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    // Try to get error details from response
    let errorMessage = `Transcription request failed with status ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData.message || errorData.detail) {
        errorMessage = errorData.message || errorData.detail || errorMessage;
      }
    } catch {
      // If response is not JSON, use default error message
    }
    throw new Error(errorMessage);
  }

  const data = (await res.json()) as TranscribeAudioResponse;
  return data;
}
